<template>
  <div>
    <div class="text-left">
      <div class="section-icon">👽</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>Some traits about me</h1>
      <ul>
        <li>I am a talker. I like to talk with everyone about everything.</li>
        <li>
          I know how to ride a horse. I worked at a friend's horse breeding
          farm. I even know how to operate tractors and their attachments.
        </li>
        <li>
          I've always wanted to learn to play drums. Never did it (but I will
          some day)!
        </li>
        <li>
          I was part of a subculture club that was organizing punk, metal and
          rock concerts. Had a lot of beer back then.
        </li>
        <li>
          My older son is from my wife's previous relationship, but I consider
          him my son and he considers me his father. We clicked the first time
          we saw each other and I take special pride in that.
        </li>
        <li>
          I drive a motorcycle and I think it's the best damn thing in this
          world. It's sort of my therapy. I try to ride all the time (when the
          weather allows it). The older son also rides with me. It's sort of our
          bonding time.
        </li>
        <li>I'm intrigued about that one team member with a creepy hobby.</li>
      </ul>
    </div>
    <!-- ./ block -->
  </div>
</template>

<script>
export default {
  name: 'Traits'
}
</script>

<style></style>
